import { useSelector } from "react-redux";
import { isRunningInTest } from "../utils/env";

/**
 * Hook that determines if the current user has access to AI features.
 *
 * AI access is granted when the tenant-level aiEnabled flag is true.
 *
 * @returns {boolean} True if user has AI access, false otherwise
 */
export default function useHasAiAccess() {
  const tenantAiEnabled = useSelector((state) => state?.auth?.aiEnabled);

  // In tests, treat as if AI is enabled
  if (isRunningInTest || process.env.NODE_ENV === "development") {
    return true;
  }

  return !!tenantAiEnabled;
}
